var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelcia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 58,
    viewBox: "0 0 200 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 58,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,66.469a29.429,29.429,0,0,0,22.75,28.6",
    transform: "translate(0 -37.822)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.481,
    y1: 32.32,
    transform: "translate(0.269 24.928)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.141,58,32.478,0A29.764,29.764,0,0,0,16.9,9.315L35.881,57.867c.743.074,1.5.1,2.259.133",
    transform: "translate(-9.58)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.385,57.842l-22.5,32.32a29.427,29.427,0,0,0,22.752-28.6,30.1,30.1,0,0,0-.254-3.718",
    transform: "translate(-47.563 -32.913)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.163,0l-5.65,58c.753-.035,1.5-.059,2.262-.133L91.75,9.315A29.757,29.757,0,0,0,76.163,0",
    transform: "translate(-39.98)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.948,63.421c-5.166.014-8.237-3.67-8.237-8.578-.026-4.941,3.09-8.741,8.093-8.757a10.234,10.234,0,0,1,5.249,1.283l.332-4.094a16.6,16.6,0,0,0-5.483-.981c-8.218.016-13.275,4.669-13.267,12.915.045,8.132,5.481,12.028,13.334,12.019a23.632,23.632,0,0,0,5.486-.78l-.211-4.04a13.159,13.159,0,0,1-5.294,1.015",
    transform: "translate(-93.912 -24.066)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.354,42.392h-.239L406.174,67.029h4.6l2.543-5.712h9.272l2.545,5.712H430.3Zm-3.739,16.024,3.317-7.453,3.341,7.453Z",
    transform: "translate(-230.297 -24.122)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,52.673c-3.135-1.344-4.9-1.965-4.924-4,0-1.745,1.516-2.92,3.839-2.92a9.933,9.933,0,0,1,6.242,2.089v-4.21a19.487,19.487,0,0,0-6.1-1.071c-5.28,0-8.749,2.592-8.692,6.709a5.83,5.83,0,0,0,2.054,4.571c.922.835,2.017,1.42,4.65,2.552,3.68,1.589,5.149,2.544,5.154,4.476,0,2.179-1.91,3.628-4.517,3.628a16.489,16.489,0,0,1-7.061-2v4.345a25.923,25.923,0,0,0,6.621.941c5.938,0,9.623-2.816,9.568-7.559-.033-3.656-2.057-5.476-6.829-7.552",
    transform: "translate(-185.894 -24.219)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.188,42.294h-4.829V66.977H295.61V63.213h-9.422Z",
    transform: "translate(-159.528 -24.066)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.822,
    height: 24.62,
    transform: "translate(165.444 18.27)",
    fill: "#ff812d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.942,67.04H242.52V63.2h-9.628V56.215h8.832V52.356h-8.832v-6.1h9.628V42.4H227.942Z",
    transform: "translate(-129.241 -24.128)",
    fill: "#ff812d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelcia);
export default __webpack_public_path__ + "static/media/Celcia.8d1d43c049cb64c8f71955b72411df15.svg";
export { ForwardRef as ReactComponent };